<!-- <p>
  juvenile works!
</p> -->
 <!-- <div *ngIf="isDefenseAttorneyUser()">
 Defense Attorney View {{getLoggedInUser() | json}}
</div>

<div *ngIf="isDistrictAttorneyUser()"> -->
  <!-- District Attorney View -->
  <div class="container-fluid">
    <div class="juvenile-user-notice" *ngIf="isICMSReleased">
      <h4>
        <b>Please note that…</b>
      </h4>
      <p>
          This program no longer shows case information for all counties in North Carolina.
      </p>
      <p>
          The North Carolina Courts are implementing new court technology to improve access to justice for all North Carolinians. To search for or view public court case information for counties which already have the new technology, please visit <b>https://www.nccourts.gov/ecourts#portal-10445</b> on any device with internet access.
      </p>
    </div>
    <h3 id="main-area-header-label" class="row"> Juvenile Case Search</h3>
    <div class="row">
      <div class="col-xs-12 col-md-3 col-lg-2" id="juvenile-search-criteria-div">
      <form #juvenileSearchForm [formGroup]="juvenileSearchFormGroup" autocomplete="off">
  
        <accordion [closeOthers]="true">
          <!-- Moved Party Name End -->        
          <accordion-group [isOpen]="false" #caseNumberGroup>
              <div
                accordion-heading
                id="juvenile-search-criteria-overhead-search-by-case-number"
                tabindex="50"
                class="search-criteria-overhead"
                (click)="selectAccordion('caseNumber', $event)">
                <i class="glyphicon pull-left"
                  [ngClass]="{'glyphicon-triangle-bottom': caseNumberGroup?.isOpen, 'glyphicon-triangle-right': !caseNumberGroup?.isOpen}"></i>               
                Case Number
              </div>
              <div formGroupName="caseLookup">
                <div id="juvenile-county-select" 
                    [ngClass]="{'has-error':!juvenileSearchFormGroup.get('caseLookup.county').valid && submitted}">
                  <label class="search-control-label"><span class="field-code">V474 </span>Case County</label>
                  <select tabindex="51" formControlName="county" class="form-control" formControlName="county">        
                    <option *ngFor="let county of countyList" [ngValue]="county">
                      {{ county }}
                    </option>       
                  </select>
                  <div class="control-label has-error"
                      *ngIf="submitted &&
                          juvenileSearchFormGroup.get('caseLookup.county').hasError('required')">
                      County is required.
                  </div>
                </div>
                <div>&nbsp;</div>
                <div [ngClass]="{'has-error':(juvenileSearchFormGroup.get('caseLookup.caseNumber').errors)
                                && (submitted
                                    || juvenileSearchFormGroup.get('caseLookup.caseNumber').dirty || juvenileSearchFormGroup.get('caseLookup.caseNumber').hasError('blur')
                                    )}">
                  <label class="search-control-label"><span class="field-code">V475 </span>Case Number</label>
                  <input id="juvenile-case-number-input"
                        tabindex="52"
                        name="casenumber"
                        type="text"
                        (keypress)="updateValidity($event, 'caseLookup.caseNumber', 'caseLookup');"
                        (blur) = "updateValidity($event, 'caseLookup.caseNumber', 'caseLookup');"
                        (focus) = "updateValidity($event, 'caseLookup.caseNumber','caseLookup');"
                        class="form-control input-sm"
                        formControlName="caseNumber"
                        appFocusable>                  
                  <div class="control-label has-error"
                  *ngIf="((submitted  && juvenileSearchFormGroup.get('caseLookup.caseNumber').hasError('required'))
                          || (juvenileSearchFormGroup.get('caseLookup.caseNumber').hasError('blur') && juvenileSearchFormGroup.get('caseLookup.caseNumber').hasError('required')))">
                      Case Number is required.
                  </div>
                  <div class="control-label has-error"
                      *ngIf="(submitted 
                      || juvenileSearchFormGroup.get('caseLookup.caseNumber').dirty
                      || juvenileSearchFormGroup.get('caseLookup.caseNumber').touched)
                      && 
                      juvenileSearchFormGroup.get('caseLookup.caseNumber').hasError('pattern')">
                       Please enter a valid court case number. Example: 17JB123456.
                  </div>
                </div>
              </div>
              <div>&nbsp;</div>
              <div align="center">
                <button id="juvenile-search-btn" tabindex="53" class="btn btn-primary" (click)="onSearch()"
                  popover="Please correct the highlighted errors." triggers="" placement="right" #pop="bs-popover"
                  (mouseenter)="(!juvenileSearchFormGroup.get('caseLookup.caseNumber').valid && submitted)? pop.show() : pop.hide();"
                  (mouseleave)="pop.hide();"><i class="glyphicon glyphicon-search"></i> Search</button>
                <button id="juvenile-start-over-btn" tabindex="54" class="btn btn-primary" (click)="startOver()">Clear Form</button>
              </div>
            </accordion-group> 
        <!-- Moved Party Name Here -->
        <accordion-group [isOpen]="true" #juvenileNameSearchGroup>
          <div
            accordion-heading
            id="juvenile-search-criteria-overhead-search-by-other"
            tabindex="55"
            class="search-criteria-overhead"
            (click)="selectAccordion('juvenile', $event)">
            <i class="glyphicon pull-left"
              [ngClass]="{'glyphicon-triangle-bottom': juvenileNameSearchGroup?.isOpen, 'glyphicon-triangle-right': !juvenileNameSearchGroup?.isOpen}"></i>
            Juvenile
          </div>
          <div formGroupName="nameSearch">
            <div *ngIf="juvenileSearchFormGroup.get('nameSearch.searchBy').value === 'Name'">
              <label class="search-control-label"><span class="field-code">J003 </span>Counties</label>
              <div>
                <ss-multiselect-dropdown
                  id="juvenile-multi-counties-select"
                  tabindex="57"
                  appSsMultiselectDropdownTabindexMigrator
                  [options]="counties"
                  [settings]="{enableSearch: true, dynamicTitleMaxItems: 1, showCheckAll: true, showUncheckAll: true, displayAllSelectedText: true, buttonClasses: 'btn btn-default btn-sm btn-multi-select',  containerClasses:'full-width'}"
                  [texts]="{checkAll: 'Select all', uncheckAll: 'Unselect all', checked: 'county selected', checkedPlural: 'counties selected', searchPlaceholder: 'Find', defaultTitle: 'ALL', allSelected: 'ALL'}"
                  formControlName="counties"></ss-multiselect-dropdown>
                  <div id="juvenile-multi-counties-selections">
                    <span class="juvenile-multi-selections-label">Selected:</span> <span id="juvenile-multi-counties-selections-values" class="juvenile-multi-selections-values">{{ getSelectedCounties() }}</span>
                  </div>
              </div>
            </div>
            <hr *ngIf="juvenileSearchFormGroup.get('nameSearch.searchBy').value === 'Name'" class="search-criteria-divider">            
            <div>
              <input id="juvenile-search-business-name" name="searchBy" checked
                     tabindex="190" 
                     type="radio" 
                     formControlName="searchBy" value="Name"><span class="field-code">J005 </span>&nbsp;Name
                     <input id="juvenile-search-business-name" name="searchBy" 
                     tabindex="190" 
                     type="radio" 
                     formControlName="searchBy" value="NCJoinNumber"><span class="field-code">J004 </span>&nbsp;NC-JOIN Number
            </div>
  
            <div [ngClass]="{'has-error': (submitted && juvenileSearchFormGroup.get('nameSearch.searchValue').invalid) 
            || juvenileSearchFormGroup.get('nameSearch').hasError('nonNumeric') || juvenileSearchFormGroup.get('nameSearch').hasError('nameValCheck')}">
              <label class="search-control-label"><span class="field-code">J006 </span></label>
              <div>
                <input id="juvenile-last-name-input"
                    name="searchValue"
                    tabindex="250"
                    type="text"
                    class="form-control input-sm"
                    formControlName="searchValue" (change)="leftPadZeros()" [maxLength]="setMaxLength() === true ? 1000:7"
                    appFocusable >
                </div>  
              <div class="control-label has-error"
              *ngIf="(juvenileSearchFormGroup.get('nameSearch.searchBy').value === 'Name') && (submitted && juvenileSearchFormGroup.get('nameSearch.searchValue').hasError('required'))">
                  Juvenile Name is required.
              </div>
              <div class="control-label has-error"
              *ngIf="(juvenileSearchFormGroup.get('nameSearch.searchBy').value === 'NCJoinNumber') && (submitted && juvenileSearchFormGroup.get('nameSearch.searchValue').hasError('required'))">
                  NC-JOIN Number is required.
              </div>
              <div class="control-label has-error"
                *ngIf=" juvenileSearchFormGroup.get('nameSearch').hasError('nameValCheck') && juvenileSearchFormGroup.get('nameSearch').hasError('emptyFlag')">
                 Juvenile Name is required.
            </div>
            <div class="control-label has-error"
                *ngIf=" juvenileSearchFormGroup.get('nameSearch').hasError('nonNumeric') && juvenileSearchFormGroup.get('nameSearch').hasError('emptyFlag')">
                NC-JOIN Number is required.
            </div> 
              <div class="control-label has-error"
                  *ngIf="juvenileSearchFormGroup.get('nameSearch').hasError('nameValCheck')  && !juvenileSearchFormGroup.get('nameSearch').hasError('emptyFlag')">
                  Should not have special characters.
              </div>
              <div class="control-label has-error"
                  *ngIf="juvenileSearchFormGroup.get('nameSearch').hasError('nonNumeric') && !juvenileSearchFormGroup.get('nameSearch').hasError('emptyFlag')">
                  Must be all numeric.
              </div>
            </div>
            <hr class="search-criteria-divider" *ngIf="juvenileSearchFormGroup.get('nameSearch.searchBy').value === 'Name'">            
              <div *ngIf="juvenileSearchFormGroup.get('nameSearch.searchBy').value === 'Name'">
              <label class="search-control-label">Case Years</label>
              <div class="column-count-2 text-align-left">
                  <div [ngClass]="{'has-error': (submitted 
                  || juvenileSearchFormGroup.get('nameSearch.fromYear').touched 
                  || juvenileSearchFormGroup.get('nameSearch.fromYear').dirty) 
                  && ( juvenileSearchFormGroup.get('nameSearch.fromYear').invalid
                    || juvenileSearchFormGroup.get('nameSearch').hasError('fromGreater'))}">
                  <label class="search-control-label"><span class="field-code">V479.a </span>From</label>
                  <input id="civil-search-years-from" type="number"  name="fromYear"
                        tabindex="255" maxlengh="4" size="4" 
                        (keypress)="updateValidity($event, 'nameSearch.fromYear', 'nameSearch');"
                        (blur)="updateValidity($event, 'nameSearch.fromYear', 'nameSearch');"
                        (focus)="updateValidity($event, 'nameSearch.fromYear', 'nameSearch');"
                        formControlName="fromYear" 
                        class="form-control civil-search-year-input input-sm" 
                        [min]="minYear" [max]="maxYear" (blur)="setDefaultYear()"/>
                </div>
                <div [ngClass]="{'has-error': (submitted
                                || juvenileSearchFormGroup.get('nameSearch.toYear').touched
                                || juvenileSearchFormGroup.get('nameSearch.toYear').dirty)
                                && ( juvenileSearchFormGroup.get('nameSearch.toYear').invalid
                                  || juvenileSearchFormGroup.get('nameSearch').hasError('fromGreater'))}">
                  <label class="search-control-label"><span class="field-code">V479.b </span>Through</label>
                  <input id="civil-search-years-to" type="number" name="toYear"
                        tabindex="260" maxlength="4" size="4" 
                        (keypress)="updateValidity($event, 'nameSearch.toYear', 'nameSearch');"
                        (blur)="updateValidity($event, 'nameSearch.toYear', 'nameSearch');"
                        (focus)="updateValidity($event, 'nameSearch.toYear', 'nameSearch');"
                        formControlName="toYear" 
                        class="form-control civil-search-year-input input-sm" 
                        [min]="minYear" [max]="maxYear" (blur)="setDefaultYear()" />
                </div>
              </div>
              <div [ngClass]="{'has-error': (submitted 
                                              || juvenileSearchFormGroup.get('nameSearch.fromYear').touched 
                                              || juvenileSearchFormGroup.get('nameSearch.fromYear').dirty
                                              || juvenileSearchFormGroup.get('nameSearch.toYear').touched
                                              || juvenileSearchFormGroup.get('nameSearch.toYear').dirty)  
                          && ( juvenileSearchFormGroup.get('nameSearch.fromYear').errors
                            || juvenileSearchFormGroup.get('nameSearch.toYear').errors
                            || juvenileSearchFormGroup.get('nameSearch').hasError('fromGreater'))}">
              <div class="control-label has-error"
                  *ngIf="(submitted
                  || juvenileSearchFormGroup.get('nameSearch.fromYear').touched 
                  || juvenileSearchFormGroup.get('nameSearch.fromYear').dirty
                  || juvenileSearchFormGroup.get('nameSearch.toYear').touched
                  || juvenileSearchFormGroup.get('nameSearch.toYear').dirty )  
                  && (juvenileSearchFormGroup.get('nameSearch.fromYear').hasError('pattern')
                   || juvenileSearchFormGroup.get('nameSearch.fromYear').hasError('min')
                   || juvenileSearchFormGroup.get('nameSearch.fromYear').hasError('max')
                   || juvenileSearchFormGroup.get('nameSearch.toYear').hasError('pattern')
                   || juvenileSearchFormGroup.get('nameSearch.toYear').hasError('min')
                   || juvenileSearchFormGroup.get('nameSearch.toYear').hasError('max')
                   || juvenileSearchFormGroup.get('nameSearch').hasError('fromGreater'))">
                  <!-- From year format must be CCYY and must be neither before 1966 nor a future year.  For example, 1997. -->
                  Please enter a valid date range between 1966 and today.
              </div>  
              </div>            
              <div class="control-label has-error"
                  *ngIf="submitted &&
                      (juvenileSearchFormGroup.get('nameSearch').hasError('isFromYearGreater'))">
                   From year must be before Through year.
              </div>  
            </div>
          </div>
          <div align="center"> 
            <button id="juvenile-search-btn" tabindex="400" class="btn btn-primary" (click)="onSearch()"
              popover="Please correct the highlighted errors." triggers="" placement="right" #partypop="bs-popover"
              (mouseenter)="(!juvenileSearchFormGroup.get('nameSearch').valid && submitted)? partypop.show() : partypop.hide();"
              (mouseleave)="partypop.hide();"><i class="glyphicon glyphicon-search"></i> Search</button>        
            <button id="juvenile-start-over-btn"  tabindex="401" class="btn btn-primary" (click)="startOver()">Clear Form</button>
          </div>            
        </accordion-group> 
        <div class="footer">
          <span>All information displayed on this site is subject to the disclaimer posted 
          <a id="civil-disclaimer-view-lnk" tabindex="5000" (click)="openDisclaimer();">here</a>.</span>
        </div>                        
        </accordion>
        <div *ngIf="(!showFieldCodeFlag && !isProd())" class="show-field-code" title="Click to show field code" (click)="toggleFieldCodes()">    </div>
        <div *ngIf="(showFieldCodeFlag && !isProd())" class="show-field-code" title="Click to hide field code" (click)="toggleFieldCodes()">    </div>
      </form>
    </div>     
    <div class="col-xs-12 col-md-9 col-lg-10" id="juvenile-search-results-div">
      <alert type="danger" *ngFor="let error of countyServiceErrors">{{error}}</alert>
      <div *ngIf="searchCriteriaDescription" class="search-criteria-description-display">
        <span class="search-criteria-overhead-prefix">Search Results</span>
        <span>{{getTotalRecordsDescription()}} for</span>
        <span class="search-criteria-overhead-description"> {{searchCriteriaDescription}} </span>
        <br>
        <!-- <span class="search-record-last-updated-info">Note: The searched data was last updated from the system of record on {{searchRecordLastUpdateDate|date:'MM/dd/yyyy'}} at {{searchRecordLastUpdateDate|date:'jm'}}.</span> -->
      </div>
  
      <app-juvenile-search-results-table
            [cases]="getIdentitySearchCases()"
            [errors]="errors"
            [requestIsInFlight]="isRequestInFlight()">
      </app-juvenile-search-results-table>
      <div *ngIf="doesIdentitySearchCasesHaveMoreRecords()">{{getDisplayedRecordsDescription()}}
              <a (click)="getNextIdentitySearchCases()">Get more results?</a>
      </div>
    </div>
  </div> 
  <!-- <div class="footer">
    <span>All information displayed on this site is subject to the disclaimer posted 
    <a id="civil-disclaimer-view-lnk" tabindex="5000" (click)="openDisclaimer();">here</a>.</span>
  </div> -->
<!-- </div> -->


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/juvenile/juvenile.component.html